module.exports = __webpack_public_path__ + "img/other.d4be2073.png";